export enum FreshStartOrigin {
    PHONE_LOGIN_PASSWORD = "phone-login-password",
    PHONE_LOGIN_PIN = "phone-login-pin",
    PHONE_LOGIN_PIN_RECOVER = "phone-login-pin-recover",
    PHONE_LOGIN_PIN_BLOCKED = "phone-login-pin-blocked",
    PASSWORD_RECOVER_LOYALTY_CARD = "password-recover-loyalty-card",
    PASSWORD_RECOVER_CONTACT_CENTER = "password-recover-contact-center",
    PASSWORD_RECOVER_BLOCKED = "password-recover-blocked",
}

export interface FreshStartOriginConfig {
    backXTimes: number;
}

export const FRESH_START_ORIGIN_CONFIGS: Record<FreshStartOrigin, FreshStartOriginConfig> = {
    [FreshStartOrigin.PHONE_LOGIN_PASSWORD]: { backXTimes: 2 },
    [FreshStartOrigin.PHONE_LOGIN_PIN]: { backXTimes: 1 },
    [FreshStartOrigin.PHONE_LOGIN_PIN_RECOVER]: { backXTimes: 1 },
    [FreshStartOrigin.PHONE_LOGIN_PIN_BLOCKED]: { backXTimes: 1 },
    [FreshStartOrigin.PASSWORD_RECOVER_LOYALTY_CARD]: { backXTimes: 1 },
    [FreshStartOrigin.PASSWORD_RECOVER_CONTACT_CENTER]: { backXTimes: 1 },
    [FreshStartOrigin.PASSWORD_RECOVER_BLOCKED]: { backXTimes: 1 },
};

const DEFAULT_BACK_X_TIMES = 1;

export const getFreshStartOriginConfig = (origin?: string | null): FreshStartOriginConfig =>
    FRESH_START_ORIGIN_CONFIGS[origin as FreshStartOrigin] ?? { backXTimes: DEFAULT_BACK_X_TIMES };

export const getFreshStartBackPath = (origin: string | null | undefined, clientId: string): string | undefined =>
    origin ? `/auth/${clientId}` : undefined;
